// extracted by mini-css-extract-plugin
export default {"label":"alreadySeenLabel-module__label__-cyVg","checkIcon":"alreadySeenLabel-module__checkIcon__sZoA9"};